<template>
  <div>
    <Jumbotron />

    <b-container style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12" lg="4" offset-lg="4" class="px-5">
          <b-img :src="require(`@/assets/icon/services/${icon}`)" fluid />
        </b-col>
        <b-col cols="12" lg="6" offset-lg="3" class="mt-3 p-0 text-center">
          <span class="display-4">{{ title }}</span>
          <p class="text-justify mt-1 mb-0" style="font-size: 18px;">
            {{ description }}
          </p>
        </b-col>

        <b-col cols="12" lg="6" offset-lg="3" class="mt-3 p-0" v-if="extra_hour">
          <div class="p-3" style="border: 1px solid #dddddd; border-radius: 15px;">
            <h4>Durasi</h4>
            <p class="m-0" v-if="extra_hour === 1">
              <span style="font-size: 18px;">8 jam/hari</span>
              <br>
              Jika melebihi batas waktu maka akan dikenakan biaya tambahan extra hour sebesar Rp. 320.000* per jam.
            </p>
            <p class="m-0" v-else-if="extra_hour === 2">
              <span style="font-size: 18px;">12 jam/hari</span>
            </p>
          </div>
        </b-col>

        <b-col cols="12" lg="6" offset-lg="3" class="mt-3 p-0">
          <div class="p-3" style="border: 1px solid #dddddd; border-radius: 15px;">
            <h4>Tarif</h4>
            <p class="m-0" style="font-size: 18px;">
              <span v-for="(tariff, i) in tariffs" :key="i">
                {{tariff}}
                <br>
              </span>
            </p>
          </div>
        </b-col>

        <b-col cols="12" class="mt-1 text-center">
          <i>* Harga menyesuaikan kurs Euro ke Rupiah pada saat transaksi.</i>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-5" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'ServiceLayout',
  props: ['icon', 'title', 'description', 'extra_hour', 'tariffs'],
  components: {
    Jumbotron
  }
}
</script>

<style scoped>
  img.card-img-left {
    width: 300px !important;
  }

  li {
    font-size: 18px;
  }

  /* container for left/right icon & text */
  .sg-row {
    display: flex;
    justify-content: space-between;

    max-width: 80%;
    margin: 20px auto;
  }
  /* config for icon */
  .sg-row.sg-img-left .sg-col-left,
  .sg-row.sg-img-right .sg-col-right {
    flex-basis: 20%;
    text-align: center;
    font-size: 60px;
  }
  /* config for text */
  .sg-row.sg-img-right .sg-col-left,
  .sg-row.sg-img-left .sg-col-right {
    flex-basis: 80%;
    padding: 1em;
  }

  /* starguides divider */
  .sg-divider {
    display: flex;
    justify-content: end;
  }
  .sg-divider-offset {
    flex-basis: 75%;
  }
  .sg-divider-solid {
    flex-basis: 25%;

    background-color: #233c7c;
    border-radius: 8px;
    height: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceLayout/ServiceLayout.vue